import { html, View } from 'rune-ts';
import klass from './Lists.module.scss';
import { PopupStoreItemCardType, PopupStoreListType } from '../../../../features/PopupStores/type';
import { PopupStoreVisualCard } from '../../../components/cells/PopupStore/PopupStoreVisualCard';
import { map, pipe, toArray } from '@fxts/core';

interface NowListProps {
  items: PopupStoreItemCardType[];
  is_mobile: boolean;
  type: PopupStoreListType;
}

export class NowList extends View<NowListProps> {
  private _popupStoreVisualCardViews = this._makePopupStoreVisualCardViews();
  // 업커밍 버튼 ( 추후 스펙 확정되면 다시 추가될 예정, 현재는 삭제 )
  // private readonly _upcomingButtonView: ButtonAction;

  // constructor(props: NowListProps) {
  //   super(props);
  //
  //   this._upcomingButtonView = new ButtonAction({
  //     label: html`
  //       <span class="${klass.btn_text}">
  //         ${ET('mps2::popup_store::now::go_upcoming')} ${PopupStoreIcon}
  //       </span>
  //     `,
  //     type: 'blue',
  //     size: 'large',
  //     fit: true,
  //     href: `/${ET.lang}/@/popup-store?tab=upcoming`,
  //     klass: klass.goto_btn,
  //   });
  // }

  override template() {
    return html`
      <div class="${klass.visual_list_container}"">
        <div class="${klass.list} list">
          <!--  리스트 카드  -->
          ${this._popupStoreVisualCardViews}
        </div>
      </div>
    `;
  }

  private _makePopupStoreVisualCardViews() {
    const { items, is_mobile, type } = this.data;

    return pipe(
      items,
      map((item) => ({
        item,
        is_mobile,
        type,
        list: this,
      })),
      map((popup_store_visual_card_props) => new PopupStoreVisualCard(popup_store_visual_card_props)),
      toArray,
    );
  }
}
